import React from 'react';
import './DashboardHome.css'

const DashboardHome = () => {
    return (
        <div className="DashboardHome-container d-flex justify-content-center align-items-center">
            <div>
                <h2>Use Dashboard BAR toggle button for control Dashboard</h2>
            </div>
        </div>
    );
};

export default DashboardHome;